import { render, staticRenderFns } from "./audience-home1.vue?vue&type=template&id=505fa769&scoped=true&"
import script from "./audience-home1.vue?vue&type=script&lang=js&"
export * from "./audience-home1.vue?vue&type=script&lang=js&"
import style0 from "./audience-home1.vue?vue&type=style&index=0&id=505fa769&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505fa769",
  null
  
)

export default component.exports